/** @format */

import React, { useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { TextareaAutosize } from '@material-ui/core';
import TextAreaFormRest from '../../../components/Form/TextAreaFormRest';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import PlatformResellerInterface from "../../../interfaces/platform/PlatformResellerInterface";
import {LanguageToSmsContentList, ZoneToSmsTemplate, ZoneToSmsTemplateCollection} from "./WelcomeSmsConfiguration";
import useResellerAvailableSystemLanguages from "../../../modules/language/hooks/useResellerAvailableSystemLanguages";
import useSystemLanguage from "../../../modules/language/hooks/useSystemLanguage";
import i18n from "../../../core/i18n";
import I18n from "../../../components/Translate/I18n";

interface WelcomeSmsContentInterface {
    setSmsContent: (list: Array<LanguageToSmsContentList>) => void;
    smsContent: Array<LanguageToSmsContentList>;
    mainReseller: PlatformResellerInterface;
    templates: ZoneToSmsTemplateCollection;
    editId: number | null;
}

const WelcomeSmsContent = (props: WelcomeSmsContentInterface): React.ReactElement => {
    const {setSmsContent, smsContent, mainReseller, templates, editId} = props;

    const {
        resellerAvailableLanguagesCollection,
        state
    } = useResellerAvailableSystemLanguages([{name: 'platformResellerId', value: mainReseller.id}])

    const {systemLanguageCollection} = useSystemLanguage();

    const updateCallback = (
        event: any,
        stateName: string,
        typeField: string,
        typeCallback: string,
        required: boolean,
        vMax: number,
        vMin?: number
    ): void => {
        const langId = stateName.split('_');
        const newContent: Array<LanguageToSmsContentList> = [];
        if (resellerAvailableLanguagesCollection) {
            resellerAvailableLanguagesCollection['hydra:member'].map(el => {
                let item: LanguageToSmsContentList | null = null;
                smsContent.map(smsContentEl => {
                    if (smsContentEl.langId === el.systemLanguageId) {
                        if (parseInt(langId[1]) === smsContentEl.langId) {
                            item = {
                                ...smsContentEl,
                                smsContent: event.target.value
                            }
                        } else {
                            item = {...smsContentEl}
                        }
                    }
                })

                if (!item) {
                    item = {
                        langId: parseInt(langId[1]),
                        smsContent: event.target.value
                    }
                }
                newContent.push(item);
            })
            setSmsContent(newContent);
        }
    };

    return (
        <GridContainer>
            {systemLanguageCollection && resellerAvailableLanguagesCollection && resellerAvailableLanguagesCollection['hydra:member'].map(resellerLang => {
                let langMnemonic = '';
                systemLanguageCollection['hydra:member'].map(systemLanguage => {
                    if (resellerLang.systemLanguageId === systemLanguage.id) {
                        langMnemonic = systemLanguage.language
                    }
                })
                let textInput = (<GridItem key={`smsContent_${resellerLang.systemLanguageId}`} xs={12}>
                    <TextAreaFormRest
                        stateName={`smsContent_${resellerLang.systemLanguageId}`}
                        callback={updateCallback}
                        stateObjectState={null}
                        typeField={'text'}
                        displayFieldName={`notifications:welcome_sms.sms_content_in_lang`}
                        additionalContent={<I18n trans={'general:language.' + langMnemonic}/>}
                        required={false}
                        value={''}
                        vMin={4}
                        vMax={64}
                        typeCallback={'number'}
                    />
                </GridItem>)
                smsContent && smsContent.map((smsContentEl) => {
                    if (smsContentEl.langId === resellerLang.systemLanguageId) {
                        textInput = (
                            <GridItem key={`smsContent_${smsContentEl.langId}`} xs={12}>
                                <TextAreaFormRest
                                    stateName={`smsContent_${smsContentEl.langId}`}
                                    callback={updateCallback}
                                    stateObjectState={null}
                                    typeField={'text'}
                                    displayFieldName={`notifications:welcome_sms.sms_content_in_lang`}
                                    additionalContent={<I18n trans={'general:language.' + langMnemonic}/>}
                                    required={false}
                                    value={smsContentEl.smsContent}
                                    vMin={4}
                                    vMax={64}
                                    typeCallback={'number'}
                                />
                            </GridItem>
                        );
                    }
                })

                return textInput
            })}

        </GridContainer>
    );
};

export default WelcomeSmsContent;
